const footerLinks = [
  {
    title: "快速追更",
    links: [
      { label: "最新更新", href: "#updates" },
      { label: "热门连载", href: "#hot" },
      { label: "内容分类", href: "#genres" },
      { label: "新作上线", href: "#hot" },
    ],
  },
  {
    title: "使用帮助",
    links: [
      { label: "追更功能", href: "#tracking" },
      { label: "每周更新周表", href: "#schedule" },
      { label: "常见问题", href: "#faq" },
      { label: "联系我们", href: "#contact" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", href: "#top" },
      { label: "追更理念", href: "#tracking" },
      { label: "读者口碑", href: "#top" },
      { label: "内容原则", href: "#genres" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black text-background-50">虚空韩漫网</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              虚空韩漫网同步热门韩漫最新话与连载进度，新作上线即时标记。追更列表自动提醒，不再错过任何一话。
            </p>
            <div className="mt-5 flex gap-3">
              <a href="#contact" aria-label="邮箱" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-mail-line text-base"></i>
              </a>
              <a href="#contact" aria-label="微信" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#contact" aria-label="社群" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-telegram-line text-base"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-background-50">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-background-200 transition-colors hover:text-accent-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-100/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-300">© 2026 虚空韩漫网 · 专注韩漫追更与连载进度同步</p>
          <a href="#top" className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-background-300 transition-colors hover:text-accent-300">
            <i className="ri-arrow-up-line text-sm"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}